import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { productImage } from "@/lib/catalog";
import { imgSet } from "@/lib/img";

// Produktkarte ohne Scroll-Einblendung (Inhaber-Wunsch: nichts „ploppt" beim Scrollen auf).
// Nur ein dezenter Hover-Zoom auf dem Bild bleibt.
export default function ProductCard({ product, size = "default", featured = false }) {
  return (
    <article className="group card-clean overflow-hidden flex flex-col h-full" data-testid={`product-card-${product.slug}`}>
      <Link to={`/produkte/${product.slug}`} className="block">
        <div className={`relative overflow-hidden bg-cream ${size === "large" ? "aspect-[4/3]" : "aspect-[4/4]"}`}>
          <img
            {...imgSet(productImage(product), "(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw")}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-contain p-8 md:p-10 transition-transform duration-500 group-hover:scale-[1.04] group-hover:-translate-y-1"
          />
          {featured && (
            <span className="absolute top-4 left-4 bg-ink text-white text-[10px] tracking-widest uppercase font-semibold px-3 py-1 rounded-full font-body">
              Beliebt
            </span>
          )}
          <div className="absolute top-4 right-4">
            <span className="text-[10px] tracking-widest uppercase text-ink-muted font-medium font-body bg-white/80 backdrop-blur px-2.5 py-1 rounded-full">
              {product.category_label || product.categoryLabel}
            </span>
          </div>
        </div>
      </Link>
      <div className="p-6 md:p-7 flex flex-col gap-3 flex-1">
        <div>
          <Link to={`/produkte/${product.slug}`} className="hover:text-brand transition-colors">
            <h3 className="font-heading text-2xl md:text-3xl text-ink leading-tight">{product.name}</h3>
          </Link>
          <p className="text-sm text-ink-soft mt-2 leading-relaxed">{product.positioning}</p>
        </div>
        <div className="mt-auto pt-4">
          <Link
            to={`/produkte/${product.slug}`}
            className="inline-flex items-center gap-2 text-sm font-semibold font-body transition-colors"
            style={{ color: "rgb(var(--brand-text-rgb))" }}
            data-testid={`view-${product.slug}`}
          >
            Mehr erfahren <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </article>
  );
}
